import { PartnerManagedAccountOrigin } from "@redotech/crdb-enums/partners/partner-managed-account-origin";
import * as z from "zod";

import { apiScopesSchema } from "./api-token";

type StoreOrigin = `${PartnerManagedAccountOrigin}`;
const storeOriginSchema: z.ZodType<StoreOrigin, StoreOrigin> = z.enum(
  PartnerManagedAccountOrigin,
);

export const StoreSchema = z.object({
  id: z.string(),
  name: z.string(),
  storeUrl: z.string().nullable(),
  origin: storeOriginSchema,
  scopes: apiScopesSchema,
  createdAt: z.iso.datetime(),
});

export type Store = z.infer<typeof StoreSchema>;

export const storeIdSchema = z.string().min(1).max(64);
